var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.432,
    height: 510.389,
    viewBox: "0 0 200.432 510.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3017",
    "data-name": "Path 3017",
    d: "M34.548,0H0L107.836,253.927,0,510.389H34.548L142.432,253.927Z",
    fill: "#f37021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3019",
    "data-name": "Path 3019",
    d: "M34.548,0H0L107.836,253.927,0,510.389H34.548L142.432,253.927Z",
    transform: "translate(58)",
    fill: "#f37021",
    opacity: 0.358
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleArrow);
export default __webpack_public_path__ + "static/media/icon_double_arrow.82c3a3fd0d42668f60dd14df1e7d4a14.svg";
export { ForwardRef as ReactComponent };